export enum SPECIAL_CATEGORIES {
  EDITOR2 = 'editor2',
  DELETED = '___DELETED___',
}
